import http from '../utils/http'
import request from '@/utils/request'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = process.env.VUE_APP_BASE_API

export default {
    //获取首页工具
    getHome() {
        return http.get(`${resquest}/novel/public/question/hots`)
    },
    //获取工具模版参数
    getTemplate(questionType) {
        return http.get(`${resquest}/novel/public/question/template/param?questionType=${questionType}`)
    },
    // 获取官方动态分类 
    getDynamics() {
        return http.get(`${resquest}/novel/public/official/categorys`)
    },
    // 获取官方动态列表  2025-9-1 15:13 增加分页v2
    getDynamicsList(category,params) {
        return http.get(`${resquest}/novel/public/official/list?category=${category}`,params)
    },
    // 获取官方动态详情 
    getDynamicsDetail(id) {
        return http.get(`${resquest}/novel/public/official/${id}`)
    },
    getCode(params) {
        return http.post(`${resquest}/auth/app/v2/sms`, params)
    },
    // 手机号登录 
    phoneLogin(phone, code) {
        return http.post(`${resquest}/auth/app/v2/login/sms?module=novel_pc&phone=${phone}&code=${code}`)
    },
    //微信登录
    wxLogin(params) {
        return http.post(`${resquest}/auth/app/v2/login/wx/pc`, params)
    },
    // 退出登录 
    logout() {
        return http.post(`${resquest}/auth/app/v2/logout`)
    },
    // 获取用户信息 
    getUserinfo() {
        return http.get(`${resquest}/novel/pc/user/info`)
    },
    // 客服连接 
    getKefu() {
        return http.get(`${resquest}/novel/public/kefu`)
    },
    // 获取用户购买记录 
    getBuylist() {
        return http.get(`${resquest}/novel/pc/pay/order/get`)
    },
    //获取会员套餐列表 2025-7-10号 17:14 增加版本号参数 
    getViplist(params) {
        return http.get(`${resquest}/novel/public/meal`, params)
    },
    //消痕购买须知
    getReduceNoticeBuy(params) {
        return http.get(`${resquest}/novel/public/reduce/notice/buy`, params)
    },
    //会员购买须知
     getMemberNoticeBuy(params) {
        return http.get(`${resquest}/novel/public/member/notice`, params)
    },
    //获取ai消痕套餐列表
     getReducelist(params) {
        return http.get(`${resquest}/novel/public/reduce/thail`, params)
    },
    // 获取权益图标 
    getRightsicon() {
        return http.get(`${resquest}/novel/public/rights/icon`)
    },
    // 获取会员权益  2025-7-10号 17:14 新的接口 
    getRight(params) {
        return http.get(`${resquest}/novel/public/right`, params)
    },
    // 获取会员权益
    getRights() {
        return http.get(`${resquest}/novel/public/rights`)
    },
    // 获取支付二维码 
    getPay(params) {
        return http.post(`${resquest}/novel/pc/pay/recharge`, params)
    },
     // 获取支付二维码  消痕 
    getPayReduce(params) {
        return http.post(`${resquest}/novel/app/pay/reduce/native`, params)
    },
   
    //查询支付结果
    payStatus(tradeNo) {
        return http.get(`${resquest}/novel/app/pay/status/${tradeNo}`)
    },
    //获取流式内容
    getStreamContent(id, index,params) {
        return http.get(`${resquest}/novel/app/writer/pc/question/async/${id}/${index}`,params)
    },
    //ai工具（热门工具或者写作工具）
    aiHostTools(params = {}) {
        params.headers = {
            channel: 'pc'
        }
        return http.get(`${resquest}/novel/public/question/template`, params)
    },
    //小说工具 流式提问 
    getNovelstreamId(type, params) {
        return http.post(`${resquest}/novel/app/question/async/v2/${type}`, params)
    },
    //小说 流式提问 --2025年5月20号，这个接口已经废弃
    getNovelstreamIds(type, params) {
        return http.post(`${resquest}/novel/app/writer/stream4/${type}`, params)
    },
    //ai小说帮写创建时候，不需要带id --2025年5月20号
    novelHelpWrite(type, param) {
        return http.post(`${resquest}/novel/app/writer/async/${type}`, param)
    },
    //短篇，中长篇小说成功后ai帮写生成的接口，需要传id --2025年5月20号 
    novelHelpWriteId(type, param) {
        return http.post(`${resquest}/novel/app/writer/novel/async/${type}`, param)
    },
    // 创建小说   
    createNovel(params) {
        return http.post(`${resquest}/novel/app/novel/insert`, params)
    },
    //修改小说 
    modifyNovel(params) {
        return http.post(`${resquest}/novel/app/novel/update`, params)
    },
    //小说详情-新增2025-5-21日
    novelDetail(params) {
        return http.get(`${resquest}/novel/app/novel/details?novelId=${params}`,)
    },
    //删除小说 
    delNovel(params) {
        return http.post(`${resquest}/novel/app/novel/delete`, params)
    },


    //获取参数模板 
    getParameter(functionType, paramKey) {
        return http.get(`${resquest}/novel/public/writer/template/param?functionType=${functionType}&paramKey=${paramKey}`)
    },
    // 小说工具历史记录  
    getHomenovel(pageNum, params) {
         params.headers = {
            "Content-Type": 'multipart/form-data'
        }
        return http.get(`${resquest}/novel/app/question/log?pageNum=${pageNum}&pageSize=20`, params)
    },
    // 删除小说工具历史记录   
    delHomenovel(params) {
        return http.post(`${resquest}/novel/app/question/delete/log`, params)
    },
    // 小说工具历史记录详情 
    getHomenovelDetail(pageNum) {
        return http.get(`${resquest}/novel/app/question/log/details`, pageNum)
    },
    // 获取小说列表 小说信息
    getNovellist(id) {
        let url = ''
        if (id) {
            url = `/novel/pc/novel/find/novel?novelId=${id}`
        } else {
            url = `/novel/app/novel/find/novel`
        }
        return http.get(`${resquest}${url}`)
    },
    // 获取小说列表-搜索功能  2025年6月16号新增  废弃
    // getNewNovellist(params) {
    //    return http.get(`${resquest}/novel/app/novel/find/novel`,params)
    // },
    // 获取所有小说列表-搜索功能  2025年6月30号新增
    getNewNovellist(params) {
        return http.get(`${resquest}/novel/app/novel/list/all/v2`, params)
    },
    //获取小说大纲列表 
    getChapterList(id) {
        return http.get(`${resquest}/novel/app/novel/outline/find?asc=asc&novelId=${id}`)
    },
    //获取小说章节列表
    getChapterList1(id, pageNum, pageSize=10) {
        return http.get(`${resquest}/novel/app/novel/chapters?asc=asc&novelId=${id}&pageNum=${pageNum}&pageSize=${pageSize}`)
    },
    //获取小说章节详情
    getChapterFind(id, episode) {
        return http.get(`${resquest}/novel/app/novel/chapters/find?asc=asc&novelId=${id}&episode=${episode}`)
    },
    //获取最新章节
    getNewChapter(id) {
        return http.get(`${resquest}/novel/app/novel/outline/overview/find?novelId=${id}`)
    },
    // 获取默认封面 
    getCover() {
        return http.get(`${resquest}/novel/public/default/img`)
    },
    // 获取Ai生成封面记录  
    getAiCover(pageNum, pageSize) {
        return http.get(`${resquest}/novel/app/img/log/pc?pageNum=${pageNum}&pageSize=${pageSize}`)
    },
    // 生成封面 
    createCover(params) {
        return http.post(`${resquest}/novel/app/writer/text_to_img/wst`, params)
    },
    //修改封面
    modifyCover(params) {
        return http.post(`${resquest}/novel/app/novel/insert/img`, params)
    },
    //删除封面
    delCover(id) {
        return http.post(`${resquest}/novel/app/img/log/delete/${id}`)
    },
    // 保存大纲--2025-6-3 修改接口pc换成app 
    saveNovelOutline(params) {
        params.headers = {
            "Content-Type": 'application/json;charset=utf-8'
        }
        return http.post(`${resquest}/novel/app/novel/outline/insert`, params)
    },
    // 批量-删除大纲章节
    delNovelOutline(params) {
        return http.post(`${resquest}/novel/app/novel/chapters/delete/batch`, params)
    },
    //手写大纲 
    handNovelOutline(params) {
        return http.post(`${resquest}/novel/app/reading/outline/novel`, params)
    },
    //短剧手写大纲 废弃
    handDJOutline(params) {
        return http.post(`${resquest}/novel/app/reading/outline/text`, params)
    },
    //短剧手写大纲 新增手写大纲的接口，可编辑可保存
    handDJOutlineSave(params) {
        return http.post(`${resquest}/novel/app/reading/outline/script`, params)
    },
    //获取大纲总和 
    getTotalOutline(novelId) {
        return http.get(`${resquest}/novel/app/novel/outline?novelId=${novelId}`)
    },
    //获取前面大纲总和  
    getFrontOutline(novelId, number) {
        return http.get(`${resquest}/novel/pc/novel/previousOutline?novelId=${novelId}&number=${number}`)
    },
    //查询章节概述  
    getoverview(novelId, outlineChapterId) {
        return http.get(`${resquest}/novel/pc/novel/chapter/overview?outlineChapterId=${outlineChapterId}&novelId=${novelId}`)
    },
    // 保存章节概述 
    saveNovelChapter(params) {
        return http.post(`${resquest}/novel/app/novel/outline/overview`, params)
    },
    //查询正文 
    getNovelContent(id) {
        return http.get(`${resquest}/novel/pc/novel/text/content?id=${id}`)
    },
    // 添加章节 - 2025-6-6 17:00 修改成app接口
    addNovelChapter(params) {
        return http.post(`${resquest}/novel/app/novel/chapters/insert`, params)
    },
    //修改章节 - 2025-6-6 17:00 修改成app接口
    modifyNovelChapter(params) {
        return http.post(`${resquest}/novel/app/novel/chapters/update`, params)
    },
    // 购买记录
    payList() {
        return http.get(`${resquest}/novel/pc/pay/order/get`)
    },
    // 购买记录 -app 2025-10-17 8:52 更换pc的购买记录
    payAPPList() {
        return http.get(`${resquest}/novel/app/pay/user/records`)
    },
    //下载小说-已经更换接口 2025-5-28 16:05
    downloadText(params) {
        return http.get(`${resquest}/novel/app/novel/download`, params)
    },
    //导入正文 - 2025-6-18 14:22 
    importChapters(params) {
        params.headers = {
            "Content-Type": 'application/json;charset=utf-8'
        }
        return http.post(`${resquest}/novel/app/novel/chapters/import`, params)
    },
    //小说置顶 - 2025-6-23 10:24 
    novelTop(params) {
        return http.post(`${resquest}/novel/app/novel/top`, params)
    },
    // 正文里面的小说风格标签 
    tags(params) {
        return http.get(`${resquest}/novel/public/writer/select/tag`, params)
    },
    // ai生成停止
    aiStop(params) {
        return http.get(`${resquest}/novel/app/writer/close`, params)
    },
    // ai生成状态 2025-7-17 10:20 新增
    aiCreateState(params) {
        return http.get(`${resquest}/novel/app/writer/flag`, params)
    },
    // ai停止生成 2025-7-17 10:20 新增
    aiStopState(params) {
        return http.get(`${resquest}/novel/app/writer/stop`, params)
    },
    // 保存参数（目前是用作正文仿写的input） 2025-7-17 13:57 新增
    saveParams(params) {
        params.headers = {
            "Content-Type": 'application/json;charset=utf-8'
        }
        return http.post(`${resquest}/novel/app/lnovel/setting`, params)
    },
    // 获取参数（目前是用作正文仿写的input） 2025-7-17 13:57 新增
    getParams(params) {
        return http.get(`${resquest}/novel/app/lnovel/setting`, params)
    },
    // 作品添加收藏 2025-8-4 15:33 新增
    novelAddCollect(params) {
        return http.post(`${resquest}/novel/app/novel/collect`, params)
    },
    // 作品取消收藏 2025-8-4 15:33 新增
    novelCancelCollect(params) {
        return http.post(`${resquest}/novel/app/novel/uncollect`, params)
    },
    // 作品恢复 2025-8-4 16:49 新增
    novelRestore(params) {
        return http.post(`${resquest}/novel/app/novel/restore`, params)
    },
    //长记忆保存
    recallSave(params){
        let config = {}
        config.params = params
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
        config.timeout= 30 * 1000 // 单独设置30秒超时
        return http.postUrl(`${resquest}/novel/app/writer/recall`, config)
    },
    //取消长记忆保存
    recallStop(params){
        return http.post(`${resquest}/novel/app/novel/recall/close`, params)
    },
    //取消置顶
    untop(params){
        return http.post(`${resquest}/novel/app/novel/untop`, params)
    },
    //获取ai写作列表的统计小说数量
    novelCount(params){
        return http.get(`${resquest}/novel/app/novel/count`, params)
    },
    //pc的动态详情接口
    messageDetail(params){
        return http.get(`${resquest}/novel/public/official/get`,params)
    },
    //获取赠送字符
    getGive(){
        return http.get(`${resquest}/novel/public/tokens/give`)
    },
    //改变用户注册状态，如果用户是注册
    setUserLoginState(data){
        return  http.post(`${resquest}/novel/app/user/signIn`,data)
    },
    //非会员新人群的微信二维码，7天期限所以定期更换
    noVipNewcomerWXCode(params){
        return  http.get(`${resquest}/novel/public/qrcode`,params)
    },
    //首页轮播图
    homeSlide(params={}){
        params.position = 'pc_new'
        return  http.get(`${resquest}/novel/public/slide`,params)
    },
    //获取微信扫码二维码
    getWxQRCodeImg(params){
         return  http.get(`${resquest}/novel/app/login/qrcode`,params)
    },
    //获取用户扫码微信二维码的登录状态
    WxQRCodeLogin(params){
         return  http.get(`${resquest}/novel/app/login/status`,params)
    },
    //获取用户扫码微信二维码的登录状态
    rmtcFlag(params){
         return  http.get(`${resquest}/novel/app/subject/flag`,params)
    },
    //开始消痕
    startReduce(data) {
        return request({
        url: `${resquest}/novel/app/reduce`,
        headers: {
            "Content-Type": 'application/json;charset=utf-8'
        },
        method: 'post',
        data
        })
    },
    //详情
    getReduceDetail(params){
        return http.get(`${resquest}/novel/app/reduce/get`,params)
    },
    //消痕须知
    getReduceNotice(params){
        return http.get(`${resquest}/novel/public/reduce/notice`,params)
    },
    
    reduceList(params){
        return http.get(`${resquest}/novel/app/reduce/list`,params)
    },
    
    
    
}